// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2JUBN","fileBtn":"File_fileBtn__2Pz2U","closeBtn":"File_closeBtn__WObtM","fileSelected":"File_fileSelected__JwAQD","disabled":"File_disabled__356Y2"};